import Glyph from './Glyph';
import styles from './Header.module.css';

export default function Header() {
  return (
    <header className={styles.header}>
      <div className={styles.logo}>
        <Glyph />
      </div>
      <div className={styles.content}>
        <span>[ 00 ]</span>
      </div>
    </header>
  );
}
